/** POST /api/resolve/events/:eventId/assets (`assetTypeId` 0 = image) */
export const SNAPSHOT_ASSET_TYPE_ID = 0;

export interface SnapshotImage {
  readonly dataBase64: string;
  readonly name?: string | null;
  /** NVR wall clock encoded as UTC (`2026-10-14T22:57:35.000Z` = 22:57:35 on the recorder). */
  readonly timestamp?: string | null;
}

export interface SnapshotRequest {
  readonly assetTypeId: typeof SNAPSHOT_ASSET_TYPE_ID;
  readonly image: SnapshotImage;
}

export interface SnapshotResponse {
  readonly success: boolean;
  readonly message?: string;
  readonly snapshotId?: string;
}
